import React from 'react'
import Page from './page'

function NotFound () {
  return (
    <Page>
      <header>
        <h1>404</h1>
        <h5>Page Not Found</h5>
      </header>
    </Page>
  )
}

export default NotFound



// WEBPACK FOOTER //
// ./src/components/not-found.js